<div class="w-full px-2 lg:px-4 bg-white rounded-lg py-2 mt-2">
    <div class="lg:flex items-center lg:flex-wrap justify-between gap-2">
        <div class="flex items-center flex-wrap gap-2 mb-2 lg:mb-0">
            <p
                class="bg-fdffe4 rounded-md border border-ddd text-xs lg:text-[13px] xl:text-sm text-333 font-normal px-2 py-2 uppercase">
                Account
                Name : <span class="font-medium">{{ accountName }}</span> </p>
            <p
                class="bg-e4ffed rounded-md border border-ddd text-xs lg:text-[13px] xl:text-sm text-333 font-normal px-2 py-2 uppercase">
                Primary
                Account : <span class="font-medium">{{ primaryAccount }}</span> </p>
        </div>
        <div class="flex flex-wrap items-center justify-start gap-2">
            <!-- all firms -->
            <select [(ngModel)]="selectedFirmId" (change)="onFilterChange()"
                class="cursor-pointer bg-white border border-d9d9d9 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838">
                <option *ngIf="firms.length > 1" value="">All Firms</option>
                <option *ngFor="let firm of firms" [value]="firm.id">
                    {{ firm.name }}
                </option>
            </select>
            <!-- Date From -->
            <div class="relative">
                <input type="date" [(ngModel)]="fromDate" (change)="onFilterChange()"
                    class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
                <label
                    class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">From</label>
            </div>
            <!-- Date To -->
            <div class="relative">
                <input type="date" [(ngModel)]="toDate" (change)="onFilterChange()"
                    class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
                <label
                    class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">To</label>
            </div>
            <!-- Update Account Button -->
            <button (click)="navigateToUpdate()"
                class="cursor-pointer capitalize rounded-md border border-898989 bg-white text-898989 text-[13px] 2xl:text-[15px] font-medium px-2 xl:px-4 py-2 text-center">Update
                Account</button>

            <!-- All Accounts Button -->
            <button [routerLink]="['/accounts']"
                class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] 2xl:text-[15px] font-medium px-2 xl:px-4 py-2 text-center">All
                Accounts</button>
        </div>
    </div>

    <!-- Rows and Search -->
    <div class="flex flex-col md:flex-row justify-between items-center mt-6 mb-4 gap-4 px-1">
        <div class="flex items-center gap-4 w-full md:w-auto">
            <div class="flex items-center gap-2">
                <label class="text-[13px] font-medium text-383838">Rows:</label>
                <select [(ngModel)]="itemsPerPage" (change)="onSearchChange()"
                    class="border border-d9d9d9 rounded-md px-2 py-1 text-[13px] focus:outline-none focus:border-c19725 bg-white">
                    <option *ngFor="let count of [5, 10, 20, 50, 100]" [value]="count">{{ count }}</option>
                </select>
            </div>
            <div class="flex items-center gap-2 flex-grow md:flex-grow-0">
                <label class="text-[13px] font-medium text-383838">Search:</label>
                <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
                    placeholder="Search details..."
                    class="border border-d9d9d9 rounded-md px-3 py-1 text-[13px] w-full md:w-64 focus:outline-none focus:border-c19725" />
            </div>
        </div>
        <div class="text-[12px] text-gray-500 italic" *ngIf="transactions.length > 0">
            Showing {{ (p - 1) * itemsPerPage + 1 }} to {{ p * itemsPerPage > transactions.length ? transactions.length
            : p * itemsPerPage }} of {{ transactions.length }} transactions
        </div>
    </div>

    <!-- Table Layout -->
    <div class="overflow-x-auto w-full mt-2 space-y-2">
        <table class="listtable1 border border-d9d9d9 bg-white w-full">
            <thead class="bg-f1fffc text-444 rounded-lg">
                <tr>
                    <th
                        class="text-center font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Sr No.
                    </th>
                    <th
                        class="text-center font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Date
                    </th>
                    <th
                        class="text-left font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Account
                    </th>
                    <th
                        class="text-left font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Transaction Details
                    </th>
                    <th
                        class="text-center font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Firm
                    </th>
                    <th
                        class="text-right font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Opening Balance
                    </th>
                    <th
                        class="text-right font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Debit
                    </th>
                    <th
                        class="text-right font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Credit
                    </th>
                    <th
                        class="text-right font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Closing Balance
                    </th>
                    <th
                        class="text-center font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        Del
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of paginatedTransactions; let i = index"
                    class="hover:bg-gray-50 transition-colors">
                    <td class="text-center text-535353 font-medium text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2">
                        {{ (p - 1) * itemsPerPage + i + 1 }}
                    </td>
                    <td
                        class="capitalize text-center text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        {{ item.date }}
                    </td>
                    <td
                        class="capitalize text-left text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        {{ item.account }}
                    </td>
                    <td
                        class="capitalize text-left text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        {{ item.details }}
                    </td>
                    <td
                        class="capitalize text-center text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        {{ item.firm }}
                    </td>
                    <td
                        class="capitalize text-right text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        <ng-container *ngIf="!isMetalAccount">₹ {{ item.openingBalance | number:'1.2-2' }}</ng-container>
                        <ng-container *ngIf="isMetalAccount">{{ item.openingBalance | number:'1.3-3' }} gm</ng-container>
                        {{ item.openingBalanceCrDr }}
                    </td>
                    <td
                        class="capitalize text-right text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        <ng-container *ngIf="!isMetalAccount">₹ {{ item.debit | number:'1.2-2' }}</ng-container>
                        <ng-container *ngIf="isMetalAccount">
                            <span *ngIf="item.debit === 0">0.00</span>
                            <div *ngIf="item.debit > 0" class="text-right">
                                <span>{{ item.debit | number:'1.3-3' }} gm Net</span>
                                <div *ngIf="item.grossWeight > 0" class="text-[10px] text-gray-500 font-normal">
                                    Gs: {{ item.grossWeight | number:'1.3-3' }} gm ({{ item.purity | number:'1.2-2' }}%)
                                </div>
                            </div>
                        </ng-container>
                    </td>
                    <td
                        class="capitalize text-right text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap">
                        <ng-container *ngIf="!isMetalAccount">₹ {{ item.credit | number:'1.2-2' }}</ng-container>
                        <ng-container *ngIf="isMetalAccount">
                            <span *ngIf="item.credit === 0">0.00</span>
                            <div *ngIf="item.credit > 0" class="text-right">
                                <span>{{ item.credit | number:'1.3-3' }} gm Net</span>
                                <div *ngIf="item.grossWeight > 0" class="text-[10px] text-gray-500 font-normal">
                                    Gs: {{ item.grossWeight | number:'1.3-3' }} gm ({{ item.purity | number:'1.2-2' }}%)
                                </div>
                            </div>
                        </ng-container>
                    </td>
                    <td
                        class="capitalize text-right text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2 whitespace-nowrap font-medium">
                        <ng-container *ngIf="!isMetalAccount">₹ {{ item.closingBalance | number:'1.2-2' }}</ng-container>
                        <ng-container *ngIf="isMetalAccount">{{ item.closingBalance | number:'1.3-3' }} gm</ng-container>
                        {{ item.closingBalanceCrDr }}
                    </td>
                    <td
                        class="capitalize text-center text-535353 font-normal text-[13px] sm:text-sm 2xl:text-[15px] px-1.5 py-2">
                        <button (click)="deleteRow(i)" type="button" class="cursor-pointer">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 12V17" stroke="#bb0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M14 12V17" stroke="#bb0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M4 7H20" stroke="#bb0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
                                    stroke="#bb0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                    stroke="#bb0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </td>
                </tr>

                <!-- Empty State -->
                <tr *ngIf="transactions.length === 0">
                    <td colspan="10" class="text-center py-4 text-gray-500">
                        No Data Available
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination Controls -->
    <div *ngIf="totalPages > 1" class="flex items-center justify-center mt-6 gap-2">
        <button (click)="goToPreviousPage()" [disabled]="p === 1"
            class="inline-flex items-center justify-center w-8 h-8 rounded-md text-c19725 border border-c19725 hover:bg-[#f6f1cb] disabled:opacity-30 disabled:pointer-events-none transition-all">
            <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
            </svg>
        </button>

        <div class="flex gap-2">
            <ng-container *ngFor="let page of pageNumbers">
                <button *ngIf="page !== '...'; else ellipsis" (click)="onPageChange(+page)"
                    [class.bg-c19725]="p === page" [class.text-white]="p === page"
                    class="inline-flex items-center justify-center min-w-[32px] h-8 rounded-md text-sm font-bold text-c19725 border border-c19725 hover:bg-[#f6f1cb] transition-all">
                    {{ page }}
                </button>
                <ng-template #ellipsis>
                    <span
                        class="inline-flex items-center justify-center w-8 h-8 text-sm font-normal text-gray-400">...</span>
                </ng-template>
            </ng-container>
        </div>

        <button (click)="goToNextPage()" [disabled]="p === totalPages"
            class="inline-flex items-center justify-center w-8 h-8 rounded-md text-c19725 border border-c19725 hover:bg-[#f6f1cb] disabled:opacity-30 disabled:pointer-events-none transition-all">
            <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd" />
            </svg>
        </button>
    </div>

    <div class="text-end space-y-2 mt-4">
        <p class="text-444 font-normal text-end text-[13px] sm:text-sm 2xl:text-[15px] capitalize">Opening Balance :
            <span class="min-w-30 inline-block text-right">
                <ng-container *ngIf="!isMetalAccount">₹ {{ openingBalance | number:'1.2-2' }}</ng-container>
                <ng-container *ngIf="isMetalAccount">{{ openingBalance | number:'1.3-3' }} gm</ng-container>
                {{ openingBalanceCrDr }}
            </span>
        </p>
        <p class="text-444 font-normal text-end text-[13px] sm:text-sm 2xl:text-[15px] capitalize">Current Total (DR/CR) :
            <span class="min-w-30 inline-block text-right">
                <ng-container *ngIf="!isMetalAccount">₹ {{ currentTotalDebit | number:'1.2-2' }} DR / ₹ {{ currentTotalCredit | number:'1.2-2' }} CR</ng-container>
                <ng-container *ngIf="isMetalAccount">{{ currentTotalDebit | number:'1.3-3' }} DR / {{ currentTotalCredit | number:'1.3-3' }} CR gm</ng-container>
            </span>
        </p>
        <p class="text-444 font-normal text-end text-[13px] sm:text-sm 2xl:text-[15px] capitalize">Closing Balance :
            <span class="min-w-30 inline-block text-right font-bold">
                <ng-container *ngIf="!isMetalAccount">₹ {{ closingBalance | number:'1.2-2' }}</ng-container>
                <ng-container *ngIf="isMetalAccount">{{ closingBalance | number:'1.3-3' }} gm</ng-container>
                {{ closingBalanceCrDr }}
            </span>
        </p>
    </div>


    <!-- Print BUTTON -->
    <div class="mt-6 mb-4 flex items-center justify-center">
        <button type="button" (click)="printLedger()"
            class="w-30 sm:w-48 px-2 sm:px-4 py-2 cursor-pointer rounded-md bg-018f37 border border-018f37 text-white text-sm sm:text-base font-medium hover:bg-green-700 hover:shadow-lg transition-all duration-200">
            Print
        </button>
    </div>

</div>